import React from 'react';
import { Control } from 'react-hook-form';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { FilterRange } from '../../../../shared/api/api';
import { formatMessageHelper } from '../../../../shared/helpers/internationalization';
import { defaultRange } from './dataExplorerFieldsConfig';
import { RangeFieldTransformer } from '../FieldTransformers/FieldTransformers';

import './FilterFields.scss';
import { RangeField, transformPercentInput, transformPercentOutput } from './RangeField';

type RegionGroupComponentProps = {
  control: Control;
} & InjectedIntlProps;

export const regionFilterFields = {
  //turnover: { name: 'turnover', defaultValue: defaultRange, validations: { min: 0 } },
  coverage: { name: 'coverage', defaultValue: defaultRange, validations: { min: 0, max: 100 } },
  dateCoverage: { name: 'dateCoverage', defaultValue: defaultRange, validations: { min: 0, max: 100 } },
};

export const regionDefaultValues = {
  // turnover: regionFilterFields.turnover.defaultValue,
  coverage: regionFilterFields.coverage.defaultValue,
  dateCoverage: regionFilterFields.coverage.defaultValue,
};

export interface RegionFilterFields {
  // turnover: FilterRange;
  coverage: FilterRange;
  dateCoverage: FilterRange;
}

export const regionTransformers = [
  // new RangeFieldTransformer(regionFilterFields.turnover.name),
  new RangeFieldTransformer(regionFilterFields.coverage.name),
  new RangeFieldTransformer(regionFilterFields.dateCoverage.name),
];

const RegionGroupComponent = ({ intl, control }: RegionGroupComponentProps) => {
  return (
    <div className="data-explorer-region-group">
      <RangeField
        min={regionFilterFields.coverage.validations.min}
        max={regionFilterFields.coverage.validations.max}
        controllerProps={{ name: regionFilterFields.coverage.name, control }}
        title={formatMessageHelper(intl, 'dataExplorer.filters.coverageLabel')}
        type="percent"
        transformInput={transformPercentInput}
        transformOutput={transformPercentOutput}
      />
      <RangeField
        min={regionFilterFields.dateCoverage.validations.min}
        max={regionFilterFields.dateCoverage.validations.max}
        controllerProps={{ name: regionFilterFields.dateCoverage.name, control }}
        title={formatMessageHelper(intl, 'dataExplorer.filters.dateCoverageLabel')}
        type="percent"
        transformInput={transformPercentInput}
        transformOutput={transformPercentOutput}
      />
      {/*<RangeField*/}
      {/*  min={regionFilterFields.turnover.validations.min}*/}
      {/*  controllerProps={{ name: regionFilterFields.turnover.name, control }}*/}
      {/*  title={formatMessageHelper(intl, 'dataExplorer.filters.turnoverLabel')}*/}
      {/*  type="percent"*/}
      {/*  transformInput={transformPercentInput}*/}
      {/*  transformOutput={transformPercentOutput}*/}
      {/*/>*/}
    </div>
  );
};

export const RegionGroup = injectIntl(RegionGroupComponent);
